var Carousel = {};

//--------------
// Variables
//--------------



//--------------
// Functions
//--------------

/**
 * Init carousel images
 * @return {void}
 */
Carousel.initProjectsCarouselImage = function() {
  if (!Modernizr.touchevents) {
    enableTouchMove = false;
    direction = 'vertical';
  } else {
    enableTouchMove = true;
    direction = 'horizontal';
  }

  console.log('direction', direction);

	var projectsSwiperImage = new Swiper('.js-projects-carousel-image', {
    direction: 'vertical',
    loop: true,
    speed: 1000,
		allowTouchMove: enableTouchMove,

    // Navigation arrows
    navigation: {
      nextEl: '.js-project-carousel-button-next',
      prevEl: '.js-project-carousel-button-prev',
    },
    pagination: {
      el: '.js-project-carousel-pagination',
      type: 'bullets',
      clickable: 'true'
    },
    breakpoints: {
      1024: {
        direction: direction,
      },
      991: {
        direction: 'horizontal',
        allowTouchMove: true,
      }
    },
  });
}

/**
 * Init carousel text
 * @return {void}
 */
Carousel.initProjectsCarouselText = function() {
	var projectsSwiperText = new Swiper('.js-projects-carousel-text', {
    loop: true,
    speed: 1000,
		allowTouchMove: false,
		// effect: 'fade',

    pagination: {
      el: '.projects-carousel-pagination',
      type: 'custom',
      renderCustom: function (productionsSwiper, current, total) {
        if(current < 10) {
          current = '0'+ current;
        }

        if(total < 10) {
          total = '0'+ total;
        }

        return '<span class="current">' + current + '</span><span class="total">' + total + '</span>';
      }
    },

    // Navigation arrows
    navigation: {
      nextEl: '.js-project-carousel-button-next',
      prevEl: '.js-project-carousel-button-prev',
    },
  });
}

/**
 * Init carousel scripts
 * @return {[type]} [description]
 */
Carousel.init = function() {
	//-- Init Projects Carousel - Image
	Carousel.initProjectsCarouselImage();

	//-- Init Projects Carousel - Text
	// Carousel.initProjectsCarouselText();
}

/**
 * Destroy carousel scripts
 * @return {void}
 */
Carousel.destroy = function() {

}

//--------------
// Execution
//--------------


module.exports = Carousel;